import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../..";
import { DataStatus } from "../../types";

export const getVdaActions = (state: RootState) => state.vdaActions.data;

export const getVdaActionsStatus = (state: RootState) =>
  state.vdaActions.status;

export const getVdaActionsError = (state: RootState) => state.vdaActions.error;

export const getVdaActionById = createSelector(
  [getVdaActions, (_, id: string) => id],
  (vdaActions, id) => vdaActions.find((vdaAction) => vdaAction.id === id)
);

export const getIsVdaActionsLoaded = createSelector(
  getVdaActionsStatus,
  (status) => status === DataStatus.succeeded
);

export const getIsVdaActionsLoading = createSelector(
  getVdaActionsStatus,
  (status) => status === DataStatus.loading
);

export const getIsVdaActionsLoadingError = createSelector(
  getVdaActionsStatus,
  (status) => status === DataStatus.failed
);
